import { Typography, Box, Button } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import CriSection from "../../../components/CriSection";
import { useState } from "react";
import PdfDialog from "../../../components/PdfDialog";
import BeautySciencePlace from "../../../assets/files/beauty_science_place.pdf";

const AboutSection = () => {
  const theme = useTheme();

  const [showPdfDialog, setShowPdfDialog] = useState(false);

  const onShowResearchPaper = () => {
    setShowPdfDialog(true);
  };

  return (
    <CriSection>
      <Box
        sx={{
          display: "flex",
          width: "100%",
          flexDirection: {
            xs: "column",
            md: "row",
          },
        }}
      >
        <Box
          sx={{
            backgroundColor: theme.palette.primary.main,
            height: "300px",
            width: "100%",
            borderRadius: "12px",
            marginRight: "50px",
            flexGrow: 1,
            flexBasis: 0,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            paddingLeft: "50px",
            paddingRight: "50px",
          }}
        >
          <Typography
            sx={{
              fontSize: "24px",
              fontWeight: 400,
            }}
          >
            Published Over
          </Typography>
          <Typography
            sx={{
              fontSize: "60px",
              fontWeight: 700,
            }}
          >
            25
          </Typography>
          <Typography
            sx={{
              fontSize: "24px",
              fontWeight: 400,
            }}
          >
            Research Papers on Conservation and Natural History Topics
          </Typography>
        </Box>

        <Box
          sx={{
            flexGrow: 1,
            flexBasis: 0,
            marginTop: {
              xs: "24px",
              md: 0,
            },
          }}
        >
          <Typography
            sx={{
              fontSize: "36px",
              fontWeight: 400,
            }}
          >
            What We Do
          </Typography>

          <Typography variant="body1">
            Conservation Research Institute is a non-profit dedicated to
            conserving the Midwest's unique natural heritage. Our research
            focuses on understanding the intricate relationships between plants
            and animals, with special attention to vital pollinators like bees
            and indicator species like lichens. We use our findings to develop
            effective land management and stewardship strategies and promote
            sustainable relationship between our culture and the land. We
            collaborate with local communities and landowners, we strive to
            protect the biodiversity of the Midwest for generations to come.
            Join us in our mission to preserve the natural beauty and ecological
            integrity of this vital region.
          </Typography>

          <Button
            onClick={onShowResearchPaper}
            variant="contained"
            sx={{
              marginTop: "20px",
            }}
          >
            {"Learn More"}
          </Button>
        </Box>
      </Box>

      <PdfDialog
        open={showPdfDialog}
        onClose={() => setShowPdfDialog(false)}
        title="Beauty Science Place"
        pdfUrl={BeautySciencePlace}
      />
    </CriSection>
  );
};

export default AboutSection;
